// src/router/index.js
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export const constantRoutes = [
    {
        path: '/',
        name: 'auth',
        component: () => import("@/views/auth"),
        meta: { title: 'GEO大模型搜索优化在线询价' }
    },
    {
        path: '/quotation',
        name: 'quotation',
        component: () => import("@/views/quotation"),
        meta: { title: 'GEO大模型搜索优化在线询价' }
    },
    {
        path: '/dbQuotation',
        name: 'dbQuotation',
        component: () => import("@/views/quotationDouBao"),
        meta: { title: '抖包双搜在线询价' }
    },
    {
        path: '/q/:shareCode',
        name: 'quotationShare',
        component: () => import("@/views/quotationShare"),
        meta: { title: '报价单详情' }
    },
    // {
    //     path: '/test',
    //     name: 'HelloWorld',
    //     component: () => import("@/views/HelloWorld"),
    //     meta: { title: '我的' }
    // },
    {
        path: "/404",
        name: "404",
        component: () => import("@/views/404"),
        meta: { title: '系统错误' },
        hidden: true,
    },
];
const createRouter = () =>
    new Router({
        mode: 'history', // require service support
        scrollBehavior: () => ({
            y: 0,
        }),
        routes: constantRoutes,
    });

const router = createRouter();

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
    const newRouter = createRouter();
    router.matcher = newRouter.matcher; // reset router
}

export default router;
